import { render } from "./KpabgHepaticsPrintPage.vue?vue&type=template&id=73a7e850&scoped=true"
import script from "./KpabgHepaticsPrintPage.vue?vue&type=script&lang=js"
export * from "./KpabgHepaticsPrintPage.vue?vue&type=script&lang=js"

import "./KpabgHepaticsPrintPage.vue?vue&type=style&index=0&id=73a7e850&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73a7e850"]])

export default __exports__